import { getAllAdmins } from "./adminService"; // atau nama filemu
import { getAllEmployees } from "./employeeService";

export const getAllUsersCombined = async () => {
  try {
    const [admins, employees] = await Promise.all([
      getAllAdmins(),
      getAllEmployees(),
    ]);

    return [...admins, ...employees];
  } catch (error) {
    console.error("Gagal gabungkan data user:", error);
    return [];
  }
};
